//ANGULAR CORE
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//PRIMENG
import { AvatarModule } from 'primeng/avatar';
import { DrawerModule } from 'primeng/drawer';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { TabsModule } from 'primeng/tabs';
import { TagModule } from 'primeng/tag';
import { CardModule } from 'primeng/card';
import { ChipModule } from 'primeng/chip';
import { DividerModule } from 'primeng/divider';
import { TooltipModule } from 'primeng/tooltip';
import { CheckboxModule } from 'primeng/checkbox';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { CalendarModule } from 'primeng/calendar';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { FloatLabelModule } from 'primeng/floatlabel';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { PanelModule } from 'primeng/panel';
import { DialogModule } from 'primeng/dialog';

const PrimeNGModules: any[] = [
  AvatarModule,
  CommonModule,
  ButtonModule,
  CalendarModule,
  CardModule,
  CheckboxModule,
  ChipModule,
  DatePickerModule,
  DividerModule,
  DrawerModule,
  DropdownModule,
  FloatLabelModule,
  FormsModule,
  IconFieldModule,
  InputIconModule,
  InputNumberModule,
  InputTextModule,
  MultiSelectModule,
  OverlayPanelModule,
  ReactiveFormsModule,
  RadioButtonModule,
  SelectModule,
  TabsModule,
  TagModule,
  TooltipModule,
  PanelModule,
  DialogModule
];

@NgModule({
  imports: [
    PrimeNGModules
  ],
  exports: [
    PrimeNGModules
  ]
})
export class PrimeNGModule { }